import Utils from '../utils/index';

let lang = Utils.getLanguage();
lang = lang === 'inn' ? 'in' : lang;

const onlineHostList = new Map([
  ['ar', 'https://ar.hitpaw.com'],
  ['br', 'https://online.hitpaw.com.br'],
  ['cn', 'https://online.hitpaw.com'], //暂时没有SEO页面，先用英语占位
  ['de', 'https://online.hitpaw.de'],
  ['es', 'https://online.hitpaw.es'],
  ['en', 'https://online.hitpaw.com'],
  ['fr', 'https://online.hitpaw.fr'],
  ['id', 'https://online.hitpaw.id'],
  ['in', 'https://online.hitpaw.in'],
  ['it', 'https://online.hitpaw.it'],
  ['jp', 'https://online.hitpaw.jp'],
  ['kr', 'https://online.hitpaw.kr'],
  ['nl', 'https://online.hitpaw.nl'],
  ['ru', 'https://online.hitpaw.ru'],
  ['tr', 'https://tr.hitpaw.com'],
  ['tw', 'https://online.hitpaw.tw'],
]);

// 测试环境都先用英语，完善后再更换
const testHostList = new Map([
  ['ar', 'https://hitpaw-test.afirstsoft.cn'],
  ['br', 'https://hitpaw-test.afirstsoft.cn'],
  ['cn', 'https://hitpaw-test.afirstsoft.cn'],
  ['de', 'https://hitpaw-test.afirstsoft.cn'],
  ['es', 'https://hitpaw-test.afirstsoft.cn'],
  ['en', 'https://hitpaw-test.afirstsoft.cn'],
  ['fr', 'https://hitpaw-test.afirstsoft.cn'],
  ['id', 'https://hitpaw-test.afirstsoft.cn'],
  ['in', 'https://hitpaw-test.afirstsoft.cn'],
  ['it', 'https://hitpaw-test.afirstsoft.cn'],
  ['jp', 'https://hitpaw-test.afirstsoft.cn'],
  ['kr', 'https://hitpaw-test.afirstsoft.cn'],
  ['nl', 'https://hitpaw-test.afirstsoft.cn'],
  ['ru', 'https://hitpaw-test.afirstsoft.cn'],
  ['tr', 'https://hitpaw-test.afirstsoft.cn'],
  ['tw', 'https://hitpaw-test.afirstsoft.cn'],
]);

const onlineHost =
  process.env.REACT_APP_BUILD_ENV === 'development'
    ? testHostList.get(lang)
    : onlineHostList.get(lang);

//跳转到账号体系项目的链接
// const accountList = new Map([["login", `http://${window.location.hostname}:3001/v2/account.html#/login`]]);
const accountList = new Map([["login", `${onlineHost}/studio/account/login`]])
const editorList = new Map([['editor', `${onlineHost}/tools/`]]);

export { accountList, editorList };
